const NAMESPACE = "reportList";

const KEYS = {
    reportsTabLabel: "reportsTabLabel",
    sharedReportTabLabel: "sharedReportTabLabel",
    crossReportTabLabel: "crossReportTabLabel",
    modifyOwnershipTabLabel: "modifyOwnershipTabLabel",
    newLabel: "newLabel",
    detailBtnLabel: "detailBtnLabel",
    rollupBtnLabel: "rollupBtnLabel",
    multiInstanceBtnLabel: "multiInstanceBtnLabel",
    crossDetailBtnLabel: "crossDetailBtnLabel",
    crossRollupBtnLabel: "crossRollupBtnLabel",
    crossMappingLabel: "crossMappingLabel",
    importReportBtnLabel: "importReportBtnLabel",

    sensitiveModalOkBtnLabel: "sensitiveModalOkBtnLabel",
    sensitiveModalCancelBtnLabel: "sensitiveModalCancelBtnLabel",
    sensitiveModalHeaderBtnLabel: "sensitiveModalHeaderBtnLabel",

    accessGrantModalHeader: "accessGrantModalHeader",
    accessGrantCloseBtnLabel: "accessGrantCloseBtnLabel",

    copyReportMessage: "copyReportMessage",
    copyReportConfirmLabel: "copyReportConfirmLabel",

    deleteModalHeader: "deleteModalHeader",
    deleteModalBody: "deleteModalBody",
    deleteBtnLabel: "deleteBtnLabel",

    importReportModalTitle: "importReportModalTitle",

    unshareReportModalTitle: "unshareReportModalTitle",
    unshareReportModalText: "unshareReportModalText",

    selectAUserText: "selectAUserText"
};

const MESSAGES = {
    [KEYS.reportsTabLabel]: {
        value: "Reports",
        comment: "Label for reports tab"
    },
    [KEYS.sharedReportTabLabel]: {
        value: " Shared with you",
        comment: "Label for shared tab"
    },
    [KEYS.crossReportTabLabel]: {
        value: "Cross-Program Reports",
        comment: "Label for cross program reports tab"
    },
    [KEYS.modifyOwnershipTabLabel]: {
        value: "Change report ownership (CPR Admin Only)",
        comment: "Label for the change report owner tab"
    },
    [KEYS.newLabel]: {
        value: " New:",
        comment: "Label for header"
    },
    [KEYS.detailBtnLabel]: {
        value: "Detail Report",
        comment: "Label for new detail report button"
    },
    [KEYS.rollupBtnLabel]: {
        value: "Roll-Up Report",
        comment: "Label for new roll-up report button"
    },
    [KEYS.multiInstanceBtnLabel]: {
        value: "Multi-Instance Report",
        comment: "Label for new multi-instance button"
    },
    [KEYS.crossDetailBtnLabel]: {
        value: "Cross-Program Detail Report"
    },
    [KEYS.crossRollupBtnLabel]: {
        value: "Cross-Program Roll-Up Report"
    },
    [KEYS.crossMappingLabel]: {
        value: "Configure Cross-Program Report Mapping"
    },
    [KEYS.importReportBtnLabel]: {
        value: "Import Detail Report",
        comment: "Label for import report button"
    },
    [KEYS.sensitiveModalOkBtnLabel]: {
        value: "OK"
    },
    [KEYS.sensitiveModalCancelBtnLabel]: {
        value: "Cancel"
    },
    [KEYS.sensitiveModalHeaderBtnLabel]: {
        value: "Create a Password to Protect Sensitive Report"
    },
    [KEYS.accessGrantModalHeader]: {
        value: "Access Grant for "
    },
    [KEYS.accessGrantCloseBtnLabel]: {
        value: "Close"
    },
    [KEYS.copyReportMessage]: {
        value: "Copying report..."
    },
    [KEYS.copyReportConfirmLabel]: {
        value: "OK"
    },
    [KEYS.deleteModalHeader]: {
        value: "Confirm Delete"
    },
    [KEYS.deleteModalBody]: {
        value: "Are you sure you want to delete this report?"
    },
    [KEYS.deleteBtnLabel]: {
        value: "Delete"
    },
    [KEYS.importReportModalTitle]: {
        value: "Import Report",
        comment: "Title for import report modl"
    },
    [KEYS.unshareReportModalTitle]: {
        value: "Unshare Report",
        comment: "Title for confirmation dialog when a user is unsharing a report they don't own."
    },
    [KEYS.unshareReportModalText]: {
        value:
            "This report is owned by another user. Unsharing this report will cause you and other " +
            "users to lose access to this report. Are you sure you want to unshare this report?",
        comment: "Message for confirmation dialog when a user is unsharing a report they don't own."
    },
    [KEYS.selectAUserText]: {
        value: "Select a user",
        comment: "Default text for the user selection dropdowns"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
